import { FormContent, SummaryItem } from '../../components/bookingConfirmationCard/bookingConfirmationFun';
import BookingConfirmationCard from '../../components/bookingConfirmationCard/bookingConfirmationCard';
import { ReactComponent as Download } from '../../assets/icons/trvto_download.svg';
import { getFormattedOnlyDate } from '../../utils/formatDate';
import tripImage from '../../assets/images/trvto_trip.png';

/*
 * Booking confirmation for a camp / stay (StayBooked from the backend).
 * Used by bookingConfirmation.jsx when type === 'camp'.
 */

const inr = (n) => `₹${Number(n || 0).toLocaleString('en-IN')}`;
const date = (d) => (d ? getFormattedOnlyDate(new Date(d)) : '');

function guestText(guests = {}) {
    const part = (n, one, many) => (n ? `${n} ${n === 1 ? one : many}` : '');
    return [part(guests.adults, 'Adult', 'Adults'), part(guests.children, 'Child', 'Children'), part(guests.pets, 'Pet', 'Pets')]
        .filter(Boolean)
        .join(', ');
}

export function StayData({ bookingData, userData = [], bookingId }) {
    const lead = userData[0] || {};
    return (
        <BookingConfirmationCard
            title='Your Stay'
            imgSrc={localStorage.getItem('tripImage') || tripImage}
            imgAlt='trvto_stay'
            tripName={bookingData?.title}
        >
            <div className='innerFormContent'>
                <FormContent label='Check-in' answer={date(bookingData?.startDate)} />
                <FormContent label='Check-out' answer={date(bookingData?.endDate)} />
                <FormContent label='Nights' answer={bookingData?.nights} />
                <FormContent
                    label={bookingData?.items?.length > 1 ? 'Rooms' : 'Room'}
                    answer={
                        bookingData?.items?.length
                            ? bookingData.items.map((i) => `${i.unitName || 'Room'} × ${i.rooms}`).join(', ')
                            : `${bookingData?.unitName || 'Room'} × ${bookingData?.rooms || 1}`
                    }
                />
                <FormContent label='Guests' answer={guestText(bookingData?.guests)} />
                <FormContent label='Name' answer={lead.name} />
                <FormContent label='Phone' answer={lead.phoneNumber} />
                <FormContent label='Email' answer={lead.emailId} />
                {bookingData?.specialRequests && (
                    <FormContent label='Special requests' answer={bookingData.specialRequests} />
                )}
                <FormContent label='Booking ID' answer={bookingId} />
            </div>
        </BookingConfirmationCard>
    );
}

export function StaySummaryCard({ bookingData }) {
    const a = bookingData?.amountPaid || {};
    const fee = Number(a.convenienceFee || 0);
    const paidForStay = Number(a.paid || 0) - fee;
    const remaining = Math.max(Number(a.total || 0) - paidForStay - Number(a.offerAmount || 0), 0);

    return (
        <div className='card rightCard'>
            <p className='title font24'>Summary</p>
            <div className='summaryContent'>
                <SummaryItem label='Stay' amount={inr(a.actual)} />
                {a.tax > 0 && <SummaryItem label='Tax' amount={`+ ${inr(a.tax)}`} />}
                {a.isReserved && <SummaryItem label='Reserved now' amount={inr(paidForStay)} />}
                {fee > 0 && <SummaryItem label='Convenience Fee' amount={`+ ${inr(fee)}`} />}
                <SummaryItem label='Paid' amount={inr(a.paid)} isTotal={true} />
            </div>
            {remaining > 0 && (
                <div style={{ marginTop: '20px' }}>
                    <div className='leftAmountDiv'>Remaining {inr(remaining)} to be paid at the stay (including tax)</div>
                </div>
            )}
            <button className='floatingPrintButton hideOnPrint' onClick={() => window.print()}>
                <Download /> Download
            </button>
        </div>
    );
}
